import { Link } from "react-router-dom";
import { CameraOutlined } from "@ant-design/icons";
import ViewProfileIcon from "../../../../assets/icons/ViewProfileIcon.svg";
import { MdAttachMoney, MdOutlineWork, MdLocationOn } from "react-icons/md";
import TalentIdentity from "../molecules/TalentIdentity";
import RatingRow from "../atoms/RatingRow";
import DetailRow from "../atoms/DetailRow";
import EstimateIcon from '../../../../assets/icons/EstimateIcon.svg'
import ExpIcon from '../../../../assets/icons/ExpIcon.svg'
import LocIcon from '../../../../assets/icons/LocIcon.svg'
import {ReactComponent as PlaceBidIcon} from '../../../../assets/icons/PlaceBidIcon.svg'

const STATUS_LABEL = {
  available: "Available",
  hired: "Hired",
  unavailable: "Unavailable",
};

const getDisplayValue = (value) => {
  if (typeof value === "string") {
    return value.trim() ? value : "N/A";
  }

  return value != null ? value : "N/A";
};

const MarketplaceTalentCard = ({
  talent,
  onViewProfile,
  profileUrl,
  onPlaceBid,
  selectable = false,
  selected = false,
  onToggleSelect,
}) => {
  const talentId = talent.id || talent._id;

  return (
    <div
      className={`qp-card qp-card-marketplace ${selectable ? "qp-card-selectable" : ""} ${selected ? "qp-card-selected" : ""}`}
      onClick={() => (selectable ? onToggleSelect?.(talentId) : null)}
    >
      {selectable && (
        <label
          className="qp-card-select qp-card-select-marketplace"
          onClick={(event) => event.stopPropagation()}
        >
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect?.(talentId)}
          aria-label={`Select ${talent.name}`}
          style={{
    accentColor: selected ? "#002D40" : undefined
  }}
        />
        </label>
      )}

      <div className={`qp-available-header qp-status-${talent.status}`}>
        <span className="qp-available-dot" />
        <span className="qp-available-text">{STATUS_LABEL[talent.status] ?? talent.status}</span>
      </div>

      <div className="qp-card-body-inner">
        <TalentIdentity name={talent.name} title={talent.title} avatar={talent.avatar} initials={talent.initials} online={talent.online}>
          <RatingRow
            rating={talent.rating}
            reviewCount={talent.reviewCount}
            tag="SMT"
            tagClass="qp-tag-pmt"
          />
        </TalentIdentity>

        <div className="qp-card-details">
<div className="qp-card-details">
  <DetailRow
    icon={<img src={EstimateIcon} alt="estimate" />}
    label="Estimated Amount:"
    value={getDisplayValue(talent.estimatedAmount)}
  />
  <DetailRow
    icon={<img src={ExpIcon} alt="experience" />}
    label="Experience:"
    value={getDisplayValue(talent.experience)}
  />
  <DetailRow
    icon={<img src={LocIcon} alt="location" />}
    label="Location"
    value={getDisplayValue(talent.location)}
  />
</div>
        </div>

        <div className="qp-card-buttons">
          {profileUrl ? (
            <Link
              className="qp-btn-view-full"
              to={profileUrl}
              onClick={(event) => event.stopPropagation()}
            >
              <img src={ViewProfileIcon} alt="" /> View Profile
            </Link>
          ) : (
            <button
              className="qp-btn-view-full"
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onViewProfile?.(talentId);
              }}
            >
              <img src={ViewProfileIcon} alt="" /> View Profile
            </button>
          )}
          {/* <button
            className="qp-btn-bid"
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onPlaceBid(talent, "marketplace");
            }}
          >
            <PlaceBidIcon /> Place a Bid
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default MarketplaceTalentCard;

